import styled from 'styled-components';

export const ContentItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const ContentTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;

  font-size: 14px;
  font-weight: 500;
  line-height: 23.2px;
  letter-spacing: -0.36px;
  color: #171e26;
`;

export const TitleWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 8px;
`;

interface WidthProps {
  width: string;
}

interface DistanceProps {
  selectYN: boolean;
}

export const TitleBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const TitleContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  width: 100%;
  font-weight: 500;
  font-size: 14px;
`;

export const TableHeadTh = styled.th<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  border-right: 1px solid #e8e9ea;
  padding: 10px 4px;
  background-color: #f7f8fc;
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18.85px;
  letter-spacing: -0.36px;
  color: #616161;
  &:last-child {
    border-right: none;
  }
`;
export const TablebodyTd = styled.td<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  border-right: 1px solid #e8e9ea;
  padding: 10px 4px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20.3px;
  letter-spacing: -0.32px;
  color: #222222;

  &:last-child {
    border-right: none;
  }
`;

export const BlueTag = styled.span`
  padding: 3px 8px;
  border-radius: 4px;
  background: #f2f7ff;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 15.95px;
  letter-spacing: -0.28px;
  color: #008aff;
`;

export const PriceTagBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  // gap: 6px;
`;
export const PriceTagRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
  // padding: 0 6px;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

export const Checkbox = styled.div<{ $isOn?: boolean }>`
  border-radius: 4px;
  padding: 2px 5px 2px 4px;
  display: flex;
  gap: 2px;
  align-items: center;

  font-weight: 500;
  font-size: 12px;
  color: ${({ $isOn }) => ($isOn ? '#008AFF' : '#37383c9c')};

  & > img {
    width: 16px;
    height: 16px;
  }
`;

export const DistanceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  color: #222222;
  font-size: 14px;
  font-family: 'Spoqa Han Sans Neo';
  font-weight: 500;
  line-height: 20.3px;
  word-wrap: break-word;
`;

export const DistanceButton = styled.div<DistanceProps>`
  padding: 6px 16px;
  border-radius: 9999px;
  background: ${({ selectYN }) => (selectYN ? '#222222' : '#F3F5F7')};
  color: ${({ selectYN }) => (selectYN ? '#fff' : '#989BA2')};
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
`;

export const DistanceBox = styled.div`
  display: flex;
  flex-direction: row;
  // background-color: rgba(112, 115, 124, 0.08);
  border-radius: 4px;
  padding: 4px;
  gap: 8px;
`;
